/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Parameter } from '../../core/models/common/Parameter';

/**
 * Constructor.
 * @param {string} name
 * @class
 * @extends Parameter
 * @author eric.wittmann@gmail.com
 */
export abstract class OasParameter extends Parameter {
    public in : string;

    public required : boolean;

    public allowEmptyValue : boolean;

    public constructor(name? : any) {
        if(((typeof name === 'string') || name === null)) {
            let __args = arguments;
            super(name);
            if(this.in===undefined) this.in = null;
            if(this.required===undefined) this.required = null;
            if(this.allowEmptyValue===undefined) this.allowEmptyValue = null;
            if(this.in===undefined) this.in = null;
            if(this.required===undefined) this.required = null;
            if(this.allowEmptyValue===undefined) this.allowEmptyValue = null;
        } else if(name === undefined) {
            let __args = arguments;
            super();
            if(this.in===undefined) this.in = null;
            if(this.required===undefined) this.required = null;
            if(this.allowEmptyValue===undefined) this.allowEmptyValue = null;
            if(this.in===undefined) this.in = null;
            if(this.required===undefined) this.required = null;
            if(this.allowEmptyValue===undefined) this.allowEmptyValue = null;
        } else throw new Error('invalid overload');
    }
}
OasParameter["__class"] = "io.apicurio.datamodels.openapi.models.OasParameter";
OasParameter["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.INamed"];




